export default function formatMessageContentOptionNormal ({
    mode,
    head: title,
    recommends: options,
    end: allNotText
}) {
    return {
        mode,
        title,
        allNotText: allNotText || '',
        options: options.map(item => {
            return {
                text: item
            }
        })
    }
}
